import { Button, Spinner } from '@nextui-org/react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function RequireAdmin({ children }) {
  const { user, canAccess, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Spinner size="lg" label="Cargando…" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!canAccess) {
    return (
      <div className="flex h-screen w-screen flex-col items-center justify-center gap-3 p-6 text-center">
        <h1 className="text-2xl font-semibold">Acceso denegado</h1>
        <p className="max-w-md text-default-500">
          Esta cuenta no tiene permisos para acceder al backoffice.
        </p>
        <Button color="primary" variant="flat" onPress={logout}>
          Cerrar sesión
        </Button>
      </div>
    );
  }

  return children;
}
